module.exports = __webpack_public_path__ + "media/images/front/icon_user-a96f55d43e301cd2c5f11b4575726e7c.png";